export default "__VITE_ASSET__CBm9vN$4__"